// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * MessageList - Ethereal Tech Design
 *
 * Features elegant empty state, smooth thinking animation,
 * and refined scrolling experience.
 */

.message-list {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: transparent;
}

.message-list-content {
  max-width: 900px;
  margin: 0 auto;
  padding: var(--spacing-2xl) var(--spacing-lg);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
  min-height: 100%;
}

/* ===== Empty State ===== */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  padding: var(--spacing-2xl);
}

.empty-title {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-light);
  letter-spacing: var(--letter-spacing-tight);
  color: var(--text-primary);
  margin: 0;
  background: linear-gradient(
    135deg,
    var(--text-primary) 0%,
    var(--text-secondary) 50%,
    var(--color-accent) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: text-shimmer 8s ease-in-out infinite;
  background-size: 200% 200%;
}

@keyframes text-shimmer {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

/* ===== Thinking Indicator ===== */
.thinking-dots {
  display: flex;
  gap: 8px;
  padding: var(--spacing-md) var(--spacing-lg);
  background: var(--glass-bg);
  backdrop-filter: blur(var(--blur-sm));
  -webkit-backdrop-filter: blur(var(--blur-sm));
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-full);
}

.dot {
  width: 8px;
  height: 8px;
  background: linear-gradient(135deg, var(--color-primary), var(--color-accent));
  border-radius: var(--radius-full);
  animation: thinking-pulse 1.6s ease-in-out infinite;
  box-shadow: 0 0 10px var(--color-primary-glow);
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes thinking-pulse {
  0%,
  100% {
    transform: scale(0.8);
    opacity: 0.4;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
    box-shadow: 0 0 20px var(--color-primary-glow);
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== Custom Scrollbar ===== */
.message-list::-webkit-scrollbar {
  width: 6px;
}

.message-list::-webkit-scrollbar-track {
  background: transparent;
}

.message-list::-webkit-scrollbar-thumb {
  background: var(--bg-tertiary);
  border-radius: var(--radius-full);
  transition: background var(--transition-fast);
}

.message-list::-webkit-scrollbar-thumb:hover {
  background: var(--text-tertiary);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .message-list-content {
    padding: var(--spacing-lg) var(--spacing-md);
    gap: var(--spacing-lg);
  }

  .empty-title {
    font-size: var(--font-size-2xl);
  }

  .empty-state {
    min-height: 300px;
    padding: var(--spacing-lg);
  }
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/apps/myagent/myagent_ui/src/components/MessageList.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAIF;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,2CAA2C;EAC3C,0BAA0B;EAC1B,SAAS;EACT;;;;;GAKC;EACD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,QAAQ;EACR,4CAA4C;EAC5C,2BAA2B;EAC3B,qCAAqC;EACrC,6CAA6C;EAC7C,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8EAA8E;EAC9E,iCAAiC;EACjC,mDAAmD;EACnD,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;IACV,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE;IACE,4CAA4C;IAC5C,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;AACF","sourcesContent":["/**\n * MessageList - Ethereal Tech Design\n *\n * Features elegant empty state, smooth thinking animation,\n * and refined scrolling experience.\n */\n\n@import \"../styles/variables.css\";\n\n.message-list {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: transparent;\n}\n\n.message-list-content {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: var(--spacing-2xl) var(--spacing-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xl);\n  min-height: 100%;\n}\n\n/* ===== Empty State ===== */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  text-align: center;\n  padding: var(--spacing-2xl);\n}\n\n.empty-title {\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-light);\n  letter-spacing: var(--letter-spacing-tight);\n  color: var(--text-primary);\n  margin: 0;\n  background: linear-gradient(\n    135deg,\n    var(--text-primary) 0%,\n    var(--text-secondary) 50%,\n    var(--color-accent) 100%\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: text-shimmer 8s ease-in-out infinite;\n  background-size: 200% 200%;\n}\n\n@keyframes text-shimmer {\n  0%,\n  100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n/* ===== Thinking Indicator ===== */\n.thinking-dots {\n  display: flex;\n  gap: 8px;\n  padding: var(--spacing-md) var(--spacing-lg);\n  background: var(--glass-bg);\n  backdrop-filter: blur(var(--blur-sm));\n  -webkit-backdrop-filter: blur(var(--blur-sm));\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-full);\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  background: linear-gradient(135deg, var(--color-primary), var(--color-accent));\n  border-radius: var(--radius-full);\n  animation: thinking-pulse 1.6s ease-in-out infinite;\n  box-shadow: 0 0 10px var(--color-primary-glow);\n}\n\n.dot:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes thinking-pulse {\n  0%,\n  100% {\n    transform: scale(0.8);\n    opacity: 0.4;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 1;\n    box-shadow: 0 0 20px var(--color-primary-glow);\n  }\n}\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===== Custom Scrollbar ===== */\n.message-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.message-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.message-list::-webkit-scrollbar-thumb {\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-full);\n  transition: background var(--transition-fast);\n}\n\n.message-list::-webkit-scrollbar-thumb:hover {\n  background: var(--text-tertiary);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .message-list-content {\n    padding: var(--spacing-lg) var(--spacing-md);\n    gap: var(--spacing-lg);\n  }\n\n  .empty-title {\n    font-size: var(--font-size-2xl);\n  }\n\n  .empty-state {\n    min-height: 300px;\n    padding: var(--spacing-lg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
